import { createClient } from '@supabase/supabase-js'

import { Database } from './schema'

const projectUrl = import.meta.env.VITE_API_SUPABASE_URL ?? ''
const anon = import.meta.env.VITE_API_SUPABASE_ANON_KEY ?? ''

const projectDevUrl = import.meta.env.VITE_API_DEV_SUPABASE_URL ?? ''
const projectDevKey = import.meta.env.VITE_API_DEV_SUPABASE_ANON ?? ''

const isDev = import.meta.env.VITE_APP_ENV === 'development'

console.log('app env', import.meta.env.VITE_APP_ENV)

const url = isDev ? projectDevUrl : projectUrl
const key = isDev ? projectDevKey : anon

export const supabaseApi = createClient<Database>(url, key)
